import React from "react"
import Parser from "html-react-parser"
import "./GestionarPagosBanner.css"

function GestionarPagosBanner({ valores }) {
    const ROOT = process.env.REACT_APP_CMS_STATIC;

    const accionBoton = () => {
        window.open(valores?.textoBoton?.url, "_blank");
    }

    return (
        <>
            {valores !== undefined ? (
                <div className="gestionar-pagos-banner-container-externo">
                    <div className="gestionar-pagos-banner-container">
                        <div className="gestionar-pagos-banner-container-izquierda">
                            <div className="gestionar-pagos-banner-container-texto">
                                {Parser(valores.texto.html)}
                            </div>
                            <img className="gestionar-pagos-banner-imagen-persona" src={ROOT + valores.imagen.urls[0]} alt="Imagen persona"/>
                        </div>
                        <div className="gestionar-pagos-banner-boton-container">
                            <button className="gestionar-pagos-banner-boton" onClick={() => accionBoton()}>{valores.textoBoton.text}</button>
                        </div>
                    </div>
                </div>
            ) : ("")}
        </>
    )
}

export default GestionarPagosBanner
